import React from "react";
import "./HowToBuy.css";
import { Container, Row, Col } from "react-bootstrap";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import icon1 from './assets/icon1.jpeg';

const HowToBuy = () => {
    return (
        <div className="row">
            <div className="col-1 leftcol">
                {/* <HomeLeft /> */}
            </div>
            <div className="col-10 middlecol">
                <Container className="how-to-buy my-5">
                    <h2 className="text-uppercase">Simple Steps and Detailed Follows for Our Customer's Satisfaction</h2>
                    <Row className="steps mt-4">
                        <Col md={12} className="step">
                            <img src={icon1} alt="Car" className="icon" />
                            <p><b>SELECT YOUR VEHICLE: </b>Choose your desired vehicle from our available stock or trusted direct supplier network in Thailand.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="Money" className="icon" />
                            <p><b>CONFIRM YOUR ORDER & PAYMENT: </b>Pay 50%–100% of the agreed vehicle price as required before shipment.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="Inspection" className="icon" />
                            <p><b>VEHICLE INSPECTION: </b>A pre-export inspection will be arranged according to the requirements of the destination market.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="Ship" className="icon" />
                            <p><b>SHIPPING ARRANGEMENT: </b>Once all requirements are completed, your vehicle will be booked and shipped to the destination port.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="Document" className="icon" />
                            <p><b>SHIPPING DOCUMENTS: </b>The Bill of Lading (B/L) scan and required export documents will be provided after shipment.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="Money" className="icon" />
                            <p><b>ARRIVAL & DELIVERY: </b>Your vehicle arrives at the destination port, ready for customs clearance and delivery.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="DHL" className="icon" />
                            <p><b>ORIGINAL DOCUMENTS: </b>Required original documents will be sent via DHL, and the tracking number will be provided.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon1} alt="Handshake" className="icon" />
                            <p><b>PORT CLEARANCE: </b>Once you receive the documents, you can proceed with customs clearance and collect your vehicle from the port.</p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="col-1 rightcol">
                {/* <HomeRight /> */}
            </div>
        </div>
    );
};

export default HowToBuy;